import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const EntitySVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default EntitySVG;
